import { useQuery } from 'react-query'
import { api } from '../services/api'
async function getAllCustomersActive() {
  try {
    const response = await api.get('/chamado/listar-vendedor-pedido')

    return response.data.filter(
      (customer) => customer.apelido !== '<SEM VENDEDOR>',
    )
  } catch (error) {
    console.log(error)
    return []
  }
}

export const useVendedoresMensal = () => {
  const { data: customers } = useQuery({
    queryKey: 'customers',
    queryFn: getAllCustomersActive,
    staleTime: 30 * 1000, // 30 seconds
    refetchOnWindowFocus: false,
  })

  return {
    customers,
  }
}
